import {
  getRuntimeProductAuthoring,
  isPlatformCreatorWorkspace
} from "./chunk-C6DZWYFY.js";

// src/product-authoring.ts
function isProductAuthoringEnabled() {
  if (!isProductAuthoringRuntimeAllowed()) return false;
  const runtime = getRuntimeProductAuthoring();
  if (runtime !== null) return runtime;
  if (isPlatformCreatorWorkspace()) return true;
  const viteFlag = readViteProductAuthoringFlag();
  if (viteFlag !== void 0) return viteFlag;
  return true;
}
function isProductAuthoringRuntimeAllowed() {
  return isViteDev() || isNodeDevelopment();
}
function parseAuthoringFlag(raw) {
  if (raw === "true") return true;
  if (raw === "false") return false;
  return void 0;
}
function readViteProductAuthoringFlag() {
  try {
    const env = import.meta.env;
    if (!env) return void 0;
    return parseAuthoringFlag(env.VITE_EXXAT_PRODUCT_AUTHORING);
  } catch {
    return void 0;
  }
}
function isViteDev() {
  try {
    return import.meta.env?.DEV === true;
  } catch {
    return false;
  }
}
function isNodeDevelopment() {
  return typeof process !== "undefined" && process.env.NODE_ENV === "development";
}

export {
  isProductAuthoringEnabled,
  isProductAuthoringRuntimeAllowed
};
